<template>
  <section id="partners" class="section partners-section">
    <div class="container">
      <div class="section-title" data-aos="fade-up">
        <h2>{{ $t("partners.title") }}</h2>
        <div class="section-title-subtitle">{{ $t("partners.subtitle") }}</div>
      </div>

      <p class="partners-intro" data-aos="fade-up" data-aos-delay="100"></p>

      <div class="partners-grid" data-aos="fade-up" data-aos-delay="200">
        <div v-for="(partner, index) in partners" :key="index" class="partner-item" :data-aos="'zoom-in'" :data-aos-delay="100 + index * 50">
          <div class="partner-logo">
            <img :src="getLogoPath(partner)" :alt="partner" @error="handleImageError" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PartnersSection",
  data() {
    return {
      partners: ["TOTO", "google", "sony", "lenovo", "SMC", "TPR", "中部化学株式会社", "TOYODENKI", "Oliver", "旭洋株式会社", "三菱商事", "oji", "TOSHIBA", "HITACHI", "华勤"],
    };
  },
  methods: {
    getLogoPath(partner) {
      try {
        return require(`@/assets/images/logo/${partner}.png`);
      } catch (e) {
        // 如果png不存在，尝试其他格式
        try {
          return require(`@/assets/images/logo/${partner}.jpg`);
        } catch (e) {
          try {
            return require(`@/assets/images/logo/${partner}.svg`);
          } catch (e) {
            console.warn(`Logo not found for ${partner}`);
            return "";
          }
        }
      }
    },
    handleImageError(event) {
      // 图片加载失败时的处理
      event.target.style.display = "none";
      event.target.parentElement.innerHTML = `<div class="logo-placeholder">${event.target.alt}</div>`;
    },
  },
};
</script>

<style scoped>
.partners-section {
  background: white;
}
.section-title h2 {
  font-size: 42px;
  color: var(--section-title-color);
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
  margin-top: 40px;
}

.section-title h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  border-radius: 2px;
}
.section-title-subtitle {
  color: #666;
  font-size: 18px;
  margin-top: 25px;
}

.partners-intro {
  text-align: center;
  color: #666;
  font-size: 16px;
  max-width: 800px;
  margin: 0 auto 60px;
  line-height: 1.8;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
}

.partner-item {
  background: white;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border: 2px solid #e8ecef;
  cursor: pointer;
  min-height: 140px;
  position: relative;
  overflow: hidden;
}

.partner-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(78, 106, 122, 0.03), rgba(49, 148, 178, 0.03));
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 0;
}

.partner-item:hover::before {
  opacity: 1;
}

.partner-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(49, 148, 178, 0.15);
  border-color: #3194b2;
}

.partner-logo {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.partner-logo img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: all 0.3s ease;
  opacity: 0.9;
}

.partner-item:hover .partner-logo img {
  opacity: 1;
  transform: scale(1.08);
  filter: drop-shadow(0 2px 8px rgba(49, 148, 178, 0.2));
}

.logo-placeholder {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.partner-item:hover .logo-placeholder {
  opacity: 1;
  color: #409eff;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .partner-item {
    padding: 20px;
    min-height: 100px;
  }

  .partner-logo {
    height: 60px;
  }
}
</style>
